import type { RenderAdapter } from './adapter';
import type { EmbedStyling } from '../config';
import { createIframeAdapter } from './iframe';
import { createShadowAdapter } from './shadow';

export function createRenderAdapter(opts: {
  baseUrl: string;
  mode: 'iframe' | 'shadow';
  styling: EmbedStyling;
  /** Docked-fullscreen host container, resolved by bootstrap.ts from
   * `config.dock`. Shadow mode only — see `select.ts`'s fullscreen/avatar
   * gating precedent; iframe mode has no equivalent (its presentation tree
   * lives in a separate document, same reason iframe can't do an internal
   * avatar mount either). */
  dockEl?: HTMLElement | null;
}): RenderAdapter {
  if (opts.mode === 'shadow') return createShadowAdapter({ styling: opts.styling, dockEl: opts.dockEl });
  // Theming (colorScheme / vars / css) is a shadow-mode feature: the iframe
  // renders a separate cross-boundary document that doesn't consume these.
  // Iframe mode still renders the legibility-correct light palette (components
  // carry explicit light fallbacks) — it just can't switch theme. Warn if the
  // customer asked for styling that iframe can't honour.
  const s = opts.styling;
  if (s.css || Object.keys(s.vars).length > 0 || s.colorScheme !== 'light') {
    console.warn('[Mobeus] styling (colorScheme/vars/css) requires render:"shadow"; ignored in iframe mode');
  }
  return createIframeAdapter({ baseUrl: opts.baseUrl });
}
